import React from "react";
import { StyleguideFlairSwatches } from "tsi-common-react/src/styleguide/StyleguideFlairSwatches";

import { templates } from "@reactivated";

import { StyleguideChrome } from "../components/StyleguideChrome";

export const Template = (
    props: templates.StyleguideFlairElementTemplate,
): React.JSX.Element => {
    const swatches = (
        <StyleguideFlairSwatches
            choices={props.choices}
            ribbonChoices={props.ribbon_choices}
        />
    );
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? (
                swatches
            ) : (
                <div id="element-tester">{swatches}</div>
            )}
        </StyleguideChrome>
    );
};
